import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";

import { ApiClient } from "../api-client";

import type { CurrentUserResponse } from "../generated-api";


const isClient = typeof window !== "undefined";


export const currentUserQueryOptions = queryOptions({
  queryKey: ["currentUser"],

  queryFn: async () => {
    try {
      const response = await ApiClient.api.authControllerCurrentUser();
      return response.data;
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 401) {
        return null;
      }
      throw error;
    }
  },

  // 🔒 CRITICAL FIXES
  staleTime: 1000 * 60 * 5,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  retry: false,
});


export function useCurrentUser() {
  return useQuery({
    ...currentUserQueryOptions,
    enabled: isClient, 
    select: (data: CurrentUserResponse | null) => data?.data,
  });
}

export function useCurrentUserSuspense() {
  return useSuspenseQuery({
    ...currentUserQueryOptions,
    enabled: isClient,
    select: (data: CurrentUserResponse | null) => {
      if (!data) {
        throw new Error("User not authenticated");
      }

      return data.data;
    },
  });
}
